import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/dailysummary';

const options = {
    cache: {
        maxAge: 5 * 60 * 1000,
        exclude: { query: false }
    }
}

const loadDailySummary = async ({ date_end, date_start, operation_ids, organization_ids, sensor_ids, sort, station_ids, stationtype_ids }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { date_end, date_start, operation_ids, organization_ids, sensor_ids, sort, station_ids, stationtype_ids });
  return api.get(url, options);
}

const loadCurrentQuota = async ({ date_start, date_end, operation_ids, sensor_ids, sort, station_ids, }) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const url = createUrl(END_POINT, { date_start, date_end, operation_ids, sensor_ids, sort, station_ids, });
    return api.get(url, options);
}

const loadCurrentQuotaChart = async ({ date_start, date_end, operation_ids, sensor_ids, sort, station_ids, }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { date_start, date_end, operation_ids, sensor_ids, sort, station_ids, });
  return api.get(url, options);
}

const loadVolume = async ({ date_start, date_end, operation_ids, sensor_ids, sort, station_ids, }) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const url = createUrl(END_POINT, { date_start, date_end, operation_ids, sensor_ids, sort, station_ids, });
    return api.get(url, options);
}

export {
  loadDailySummary,
  loadCurrentQuota,
  loadVolume,
  loadCurrentQuotaChart
}
